import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-component',
  templateUrl: './table-component.component.html',
  styleUrls: ['./table-component.component.css'],
})
export class TableComponentComponent implements OnInit {
  constructor() {}

  // THIS COMPONENT IS CHILD COMPONENT OF CASH-FLOW TO SHOW TABLE OF MONTHLY CASH FLOWS, BECAUSE WE NEED THIS FOR PRINTING ALSO TO SHOW 4 YEARS RECORDS

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() parentObject: any = {};

  @Input() pageName: boolean;

  @Input() projectName: string;

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/table-component/table-component.component.ts